export const isCODWithoutPartialPayment = (deliveryOption) =>
  deliveryOption.key === "cod" && deliveryOption.partialPaymentPercentage === undefined;

// One physical item is enough: the order ships as one unit. Products from before the flag existed
// (no `requiresShipping`) ship. The backend re-checks this from the product records.
export const cartRequiresShipping = (cart) =>
  (cart?.products || []).some((product) => product.requiresShipping !== false);
